/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ContactSiegeGridDto } from './ContactSiegeGridDto';
import {
    ContactSiegeGridDtoFromJSON,
    ContactSiegeGridDtoFromJSONTyped,
    ContactSiegeGridDtoToJSON,
} from './ContactSiegeGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface ContactSiegeGridDtoPaginatedResults
 */
export interface ContactSiegeGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof ContactSiegeGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<ContactSiegeGridDto>}
     * @memberof ContactSiegeGridDtoPaginatedResults
     */
    results?: Array<ContactSiegeGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof ContactSiegeGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the ContactSiegeGridDtoPaginatedResults interface.
 */
export function instanceOfContactSiegeGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ContactSiegeGridDtoPaginatedResultsFromJSON(json: any): ContactSiegeGridDtoPaginatedResults {
    return ContactSiegeGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function ContactSiegeGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactSiegeGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(ContactSiegeGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function ContactSiegeGridDtoPaginatedResultsToJSON(value?: ContactSiegeGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(ContactSiegeGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

